export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api/v1';

export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  SHOPS: '/shops',
  SHOP_DETAIL: '/shops/:id',
  CAMPAIGN_MAP: '/campaign/:nacCampaignId',
};

export default {
  API_URL,
  ROUTES,
};
